import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import InputMonetario from "components/input/InputMonetario";
import Produto from "model/administracao/cadastro/produto/Produto";
import LoteItemEmprestimo from "model/patrimonio/LoteItemEmprestimo";
import LoteComponenteOP from "model/producao/LoteComponenteOP";
import Deposito from "model/suprimentos/Deposito";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import ItemTransferencia from "model/suprimentos/ItemTransferencia";
import Transacao from "model/suprimentos/Transacao";
import TransferenciaEstoque from "model/suprimentos/TransferenciaEstoque";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Column, ColumnBodyOptions, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useRef, useState } from "react";
import EmprestimoPatrimonioService from "service/patrimonio/EmprestimoPatrimonioService";
import EstoqueInutilizavelService from "service/patrimonio/EstoqueInutilizavelService";
import ApontamentoOpService from "service/producao/ApontamentoService";
import TransfereniciaEstoqueService from "service/suprimentos/TransferenciaEstoqueService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    style?: React.CSSProperties | undefined;
    onConfirm: (transferenciaEstoque: TransferenciaEstoque) => void;
}

const estoqueInutilizavelService = new EstoqueInutilizavelService();

export default function TransferenciaInutilizavelModal(props: Props) {

    const { msgAlerta, msgErro, msgSucesso } = useToastContext();

    const [transferenciaEstoque, setTransferenciaEstoque] = useState<TransferenciaEstoque>(new TransferenciaEstoque());

    const [transferido, setTransferido] = useState<boolean>(false);

    const [transacoesEntrada, setTransacoesEntrada] = useState<Transacao[]>([]);
    const [transacoesSaida, setTransacoesSaida] = useState<Transacao[]>([]);
    const [depositos, setDepositos] = useState<Deposito[]>([]);

    const [produtosDisponives, setProdutosDisponives] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);
    const [lotesDisponiveis, setLotesDisponiveis] = useState<string[]>([]);

    const depositoOrigemRef = useRef<any>(null);



    useEffect(() => {
        estoqueInutilizavelService.getDepositos().then((data) => {
            setDepositos(data);
        }).catch((error) => {
            console.log(error);
        });

    }, [])

    useEffect(() => {
        if (!props.visible) {
            setTransferenciaEstoque(new TransferenciaEstoque());
        }
    }, [props.visible]);

    useEffect(() => {
        estoqueInutilizavelService.getProdutosDisponiveis(transferenciaEstoque.depositoOrigem).then((data) => {
            setProdutosDisponives(data);
        }).catch((error) => {
            console.log(error);
        });
    }, [transferenciaEstoque.depositoOrigem])

    const header = (
        <div style={{ textAlign: 'center', position: 'relative' }}>
            <span>Itens</span>
            <Button disabled={transferido} style={{ position: 'absolute', right: 0, bottom: '-8px' }}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                tooltip="Adicionar"
                tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => novoItem()}
            ></Button>
        </div>
    )

    function novoItem() {
        transferenciaEstoque.itens.push(new ItemTransferencia());
        setTransferenciaEstoque({ ...transferenciaEstoque });
    }

    function getLotesDisponiveis(deposito: Deposito, produto: Produto) {
        estoqueInutilizavelService.getLotesDisponiveis(deposito, produto).then((data) => {
            setLotesDisponiveis(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    function validar() {
        if (transferenciaEstoque.depositoOrigem === null || transferenciaEstoque.depositoOrigem.codigo === null) {
            msgAlerta("Depósito de Origem", "Informe o depósito de origem");
            return false;
        }
        if (transferenciaEstoque.depositoDestino === null || transferenciaEstoque.depositoDestino.codigo === null) {
            msgAlerta("Depósito de Destino", "Informe o depósito de destino");
            return false;
        }
        if (transferenciaEstoque.depositoOrigem.codigo == transferenciaEstoque.depositoDestino.codigo) {
            msgAlerta("Depósitos", "Depósito de origem e destino não podem ser iguais");
            return false;
        }


        if (transferenciaEstoque.itens.length == 0) {
            msgAlerta("Itens", "Informe os itens");
            return false;
        }

        for (let i = 0; i < transferenciaEstoque.itens.length; i++) {
            const item = transferenciaEstoque.itens[i];
            if (item.produto == null || !item.produto.codigo) {
                msgAlerta("Produto", "Informe o produto no item " + (i + 1));
                return false;
            }
            if (item.lote == null || !item.lote.lote) {
                msgAlerta("Lote", "Informe o lote no item " + (i + 1));
                return false;
            }
            if (item.quantidade == 0) {
                msgAlerta("Quantidade", "Informe a quantidade no item " + (i + 1));
                return false;
            }
        }

        return true;
    }

    const confirmar = () => {
        if (validar()) {
            props.onConfirm(transferenciaEstoque); props.setVisible(false)
        }
    }

    return (
        <Dialog header="Transferir" visible={props.visible} style={{ width: '35vw', ...props.style }} onHide={() => { props.setVisible(false) }}>
            <div className="container">

                <div className="row">
                    <label className="col col-sm-12">Depósito de Origem</label>
                    <div className="col-sm-12">
                        <Dropdown
                            disabled={transferido}
                            ref={depositoOrigemRef}
                            value={transferenciaEstoque.depositoOrigem}
                            options={depositos} optionLabel="nome"
                            onChange={(e) => setTransferenciaEstoque({ ...transferenciaEstoque, depositoOrigem: e.value })}
                            style={{ width: '30%' }}
                        />
                    </div>
                </div>

                <div className="row">
                    <label className="col col-sm-12">Depósito de Destino</label>
                    <div className="col-sm-12">
                        <Dropdown disabled={transferido} value={transferenciaEstoque.depositoDestino} options={depositos} optionLabel="nome" onChange={(e) => setTransferenciaEstoque({ ...transferenciaEstoque, depositoDestino: e.value })} style={{ width: '30%' }} />
                    </div>
                </div>

                <div className="row" style={{ marginTop: 20 }}>
                    <div className="col col-sm-12">
                        <DataTable
                            value={transferenciaEstoque.itens}
                            header={header}
                            scrollHeight="500px"
                            scrollable={true}
                            emptyMessage="Nenhum registro encontrado"
                        >
                            <Column field="produto.nome" body={(rowData) =>
                                <AutoComplete
                                    dropdown
                                    placeholder="Selecione o produto" disabled={transferido} value={rowData.produto}
                                    suggestions={produtosFiltrados} field="nome"
                                    itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                                    completeMethod={(e) => {
                                        let filtered = produtoCompleteMethod(produtosDisponives, e.query);
                                        setProdutosFiltrados(filtered);
                                    }}
                                    onChange={(e) => {
                                        if (typeof e.target.value == "string") {
                                            let prod = new Produto();
                                            prod.nome = e.target.value;
                                            rowData.produto = prod;
                                        } else {
                                            rowData.produto = e.target.value;
                                            getLotesDisponiveis(transferenciaEstoque.depositoOrigem, e.target.value);

                                        }
                                        setTransferenciaEstoque({ ...transferenciaEstoque })
                                    }}
                                    onFocus={(e) => {
                                        if (transferenciaEstoque.depositoOrigem == null || transferenciaEstoque.depositoOrigem.codigo == null) {
                                            if (depositoOrigemRef.current) {
                                                console.log(depositoOrigemRef.current);
                                                depositoOrigemRef.current.focus();
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    inputStyle={{ width: '100%' }}
                                    style={{ width: '100%' }}
                                />

                            } header="Produto"></Column>
                            <Column field="lote" header="Lote" body={(rowData, options: ColumnBodyOptions) =>
                                <Dropdown disabled={transferido} value={rowData.lote} options={lotesDisponiveis} optionLabel="lote"
                                    onChange={(e) => {
                                        rowData.lote = e.value;
                                    }}
                                    style={{ width: '100%' }}
                                />
                            }></Column>
                            <Column field="quantidade" header="Quantidade" body={(rowData) =>
                                <InputNumber disabled={transferido} value={rowData.quantidade} useGrouping={false}
                                    onFocus={(e) => e.target.select()}
                                    locale="pt-BR"
                                    minFractionDigits={1} maxFractionDigits={5} maxLength={10}
                                    onChange={(e) => {
                                        rowData.quantidade = e.value;
                                        setTransferenciaEstoque({ ...transferenciaEstoque })
                                    }}
                                    style={{ width: '100%' }}
                                />
                            }></Column>
                        </DataTable>
                    </div>
                </div>

                <div className="row" style={{ marginTop: 20 }}>
                    <div className="col col-sm-12">

                        <Button disabled={transferido} label="Transferir" onClick={() => {
                            confirmar();
                        }}></Button>
                    </div>
                </div>



            </div>

        </Dialog>
    )

}